// https://stackoverflow.com/questions/6832596/how-to-compare-software-version-number-using-js-only-number/16187766#16187766
export default function compareSemverVersionNumbers(a, b) {
	if (typeof a !== 'string' || typeof b !== 'string') return NaN

	let i, diff
	const regExStrip0 = /(\.0+)+$/
	const segmentsA = a.replace(regExStrip0, '').split('.')
	const segmentsB = b.replace(regExStrip0, '').split('.')
	const minLength = Math.min(segmentsA.length, segmentsB.length)

	for (i = 0; i < minLength; i++) {
		diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10)
		if (diff) return diff
	}
	return segmentsA.length - segmentsB.length
}
